export default __webpack_public_path__ + "media/images/paylogos/color/mastercard_secure@2x-8afe9ba82ef5b64dc3584a04f012469e.png";